import React from 'react';
import Link from 'atomic/link';
import Icon from 'atomic/icon';
import { media } from 'layouts/footer/data/footer.data';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';
import { LinkTarget } from 'atomic/link/link-target.enum';

import './footer.base.scss';

const getCurrentYear = (): number => new Date().getFullYear();

type FooterProps = {
    children: React.ReactNode;
};

const Footer: React.FC<FooterProps> = ({ children }) => (
    <footer className="footer">
        {children}
        <div className="footer__bar" data-section="footer-bar">
            <ul className="footer__bar__media">
                {
                    media.map(mediaItem => (
                        <li key={mediaItem.href} className="footer__bar__media__item">
                            <Link
                                href={mediaItem.href}
                                title={mediaItem.title}
                                rel={mediaItem.rel}
                                target={LinkTarget.BLANK}
                                className="footer__bar__media__item__link"
                            >
                                <Icon name={mediaItem.icon} size={20} />
                            </Link>
                        </li>
                    ))
                }
            </ul>
            <div className="footer__bar__list">
                <ul>
                    <li>
                        <Link href="/site/doc/9" title="Reklama" rel={SeoLinkRelEnum.NOFOLLOW}>
                            Reklama
                        </Link>
                    </li>
                    <li>
                        <Link href="/SiteMap" title="Mapa strony Skąpiec.pl">
                            Mapa strony
                        </Link>
                    </li>
                    <li>
                        <Link href="/site-map-rankings" title="Mapa rankingów Skąpiec.pl">
                            Mapa rankingów
                        </Link>
                    </li>
                    <li>
                        <Link
                            href="https://polityka-prywatnosci.onet.pl/"
                            target={LinkTarget.BLANK}
                            title="Polityka prywatności w Skąpiec.pl"
                            rel={SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER}
                        >
                            Polityka prywatności
                        </Link>
                    </li>
                    <li>
                        <Link href="/obowiazek-informacyjny" title="Obowiązek informacyjny" rel={SeoLinkRelEnum.NOFOLLOW}>
                            Obowiązek informacyjny
                        </Link>
                    </li>
                    <li>
                        <Link href="/kontakt" title="Przejdź do strony kontaktu" rel={SeoLinkRelEnum.NOFOLLOW}>
                            Zgłoś uwagi
                        </Link>
                    </li>
                    <li>
                        <Link href="/akt-uslugi-cyfrowe" title="Akt o usługach cyfrowych" rel={SeoLinkRelEnum.NOFOLLOW}>
                            Akt o usługach cyfrowych
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="footer__bar__copyrights">
                &copy;
                {`Skapiec ${getCurrentYear()}`}
            </div>
        </div>
    </footer>
);

export default Footer;
